<template>
    <div class="form-field">
        <label>动态</label>
        <div class="content">
            <!-- <el-radio-group v-model="dynamic" @change="setDynamic"> -->
                <!-- <el-radio :label="0">非动态</el-radio> -->
                <el-checkbox v-model="dynamic" @change="setDynamic">是</el-checkbox>
            <!-- </el-radio-group> -->
            <div class="tips" v-if="dynamic&&(selected.type==='text'||selected.type==='title'||selected.type==='digest'||selected.type==='advertuser')">
                *请在文本框中输入默认打底文字，若替换文字字数超过打底文字字数时，则默认显示打底文字
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-field{
        align-items: flex-start;
    }
    .tips{
        color:#aaa;
        font-size:12px;
    }
</style>

<script>
	export default {
		props:['isDynamic'],
		data(){
			return {
				dynamic: !!this.isDynamic
            }
		},
		computed: {
			selected() {
				return this.$store.state.selected
			}
		},
		methods: {
			setDynamic(value) {
                this.$store.commit('update_elm', {
                	id: this.selected.id,
                    data: {
						isDynamic: value*1
                    }
                })
                this.$store.dispatch('elm_select',{id: this.selected.id})
			}
		},
        watch:{
			isDynamic(value){
				this.dynamic = !!value
            }
        }
	}
</script>
